import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import validator from 'validator';
import { resetUser } from '../../store/features/loginUser';
import ButtonMain from '../../components/common/ButtonMain';
import FooterTrustChat from '../../components/common/FooterTrustChat';
import LeadsComp from '../../components/common/LeadsComp';
import Input from '../../components/common/InputField';
import LeadSelectInput from '../../components/common/LeadSelectInput';
import VerificationButton from '../../components/common/verificationButton';
import { ReactComponent as Dropdown } from '../../assets/images/dropdown-arrow.svg';
function Leads(props) {
  const [leadEmail, setLeadEmail] = useState(false);
  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );
  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );
  const [stateName, setStateMethod] = useState({
    email: '',
    emailInvalid: false,
    emailInvalidMessage: '',
    emailState: false,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [leadItem, setLeadItem] = useState([]);
  const [leadSetInput, setLeadSetInput] = useState('Social Media');
  const {
    setSelectOnBoarding,
    setLeadContainer,
    setLeadJobTitle,
    setEmailBoarding,
    emailBoarding,
    leadContainer,
  } = props;

  // const enableButton = () => leadItem && leadSetInput && stateName.emailState;

  const EnableHandlerOnboarding = () => {
    // if (leadItem && leadSetInput && stateName.email) {
    //   setSelectOnBoarding(3);
    // }
    setLeadContainer(leadItem);
    setLeadJobTitle(leadSetInput);
    setEmailBoarding(stateName.email);
    setSelectOnBoarding(3);
  };

  const ValidateEmail = (email) => {
    if (validator.isEmail(email) === false) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    const leadContainerValue = leadContainer;
    const emailReferral = emailBoarding;
    setLeadContainer(leadContainerValue);
    setLeadSetInput(leadContainerValue);
    setStateMethod({
      ...stateName,
      email: emailReferral,
    });
  }, []);
  const handleChange = async (event) => {
    switch (event.target.name) {
    case 'email':
      if (!ValidateEmail(event.target.value)) {
        setStateMethod({
          ...stateName,
          [event.target.name]: event.target.value,
          emailInvalidMessage: t.EMAILERROR,
          emailInvalid: true,
          emailState: false,
        });
      } else {
        setEmailBoarding(event.target.value);
        setStateMethod({
          ...stateName,
          [event.target.name]: event.target.value,
          emailInvalidMessage: '',
          emailInvalid: false,
          emailState: true,
        });
      }
      break;
    default:
      setStateMethod({
        ...stateName,
        [event.target.name]: event.target.value,
      });
    }
  };

  const logoutHandler = () => {
    dispatch(resetUser());
    navigate('/', { replace: true });
  };
  return (
    <>
      <div className="OnBoarding-Container">
        <div className="inputDivStyle-onboarding ">
          <div className="textDiv__login">
            <p className="text__create">{t.LEADS_HEADING}</p>
          </div>
          <div style={{ marginBottom: '8px' }}>
            <label htmlFor="MSG_OB_FOCUS">{t.MSG_OB_FOCUS}</label>
          </div>
          <LeadsComp
            setLeadEmail={setLeadEmail}
            leadEmail={leadEmail}
            setLeadItem={setLeadItem}
            leadItem={leadItem}
            leadContainer={leadContainer}
            setLeadContainer={setLeadContainer}
          />
          <br />
          <label htmlFor="MSG_OB_FOCUS">{t.LEADS_LABEL}</label>
          <LeadSelectInput
            value={leadSetInput}
            onChange={(e) => {
              setLeadSetInput(e);
            }}
            popupIcon={<Dropdown />}
          />
          <br />
          {leadSetInput === 'Direct Referral' ? (
            <Input
              type="email"
              id="email"
              name="email"
              value={stateName.email}
              onChange={(e) => handleChange(e)}
              error={stateName.emailInvalidMessage}
              className={clsx(
                stateName.emailInvalidMessage ? 'input__error' : '',
                stateName.emailState ? 'input__success' : ' ',
              )}
              title={t.TITLE_EMAIL}
              placeholder={t.ENTR_EML_PH}
            />
          ) : null}
          {/* <div className="btn-class">
            <VerificationButton
              title={t.BTN_CONTINUE}
              enable={enableButton()}
              onClick={() => EnableHandlerOnboarding()}
              // className="buttonStyleEnable"
            />
          </div> */}
          <div className="btn-class">
            <VerificationButton
              title={t.BTN_CONTINUE}
              enable
              onClick={() => {
                EnableHandlerOnboarding();
              }}
            />
            <ButtonMain
              title={t.BTN_BACK}
              className="btn__back"
              onClick={() => setSelectOnBoarding(1)}
            />
          </div>
          <p className="a__singIn">
            {t.SKIP_OB}
            <span className="b__signIn" onClick={logoutHandler}>
              {t.LOGOUT}
            </span>
          </p>
          {/* <div className="SkipContainer">
            <p className="skip-item" onClick={() => setSelectOnBoarding(4)}>Skip</p>
          </div> */}
        </div>
      </div>
      <FooterTrustChat />
    </>
  );
}
Leads.propTypes = {
  setSelectOnBoarding: PropTypes.func.isRequired,
  setLeadContainer: PropTypes.func.isRequired,
  setLeadJobTitle: PropTypes.func.isRequired,
  setEmailBoarding: PropTypes.func.isRequired,
  emailBoarding: PropTypes.string.isRequired,
  leadContainer: PropTypes.string.isRequired,
};
export default Leads;
